exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-chart-wrap[data-v-db82e7b8]{height:280px;position:relative}.dashboard-chart-wrap[data-v-db82e7b8] >div{height:100%!important}", ""]);

// exports
